document.addEventListener("DOMContentLoaded", function () {
  // Support multiple B2B forms on the same page
  var roots = document.querySelectorAll("section.b2b[id^='b2b-']");
  if (!roots || !roots.length) return;

  roots.forEach(function (root) {
    var WEBAPP_URL = "https://script.google.com/macros/s/AKfycbwWxSii33QlPMw6rndDYvtGofB0aBkXo8TbI-nkuSHCgcVNBVZ2ETzxTg7F_9Umsrf-/exec";

    // Helper: find within this section only
    function q(sel) { return root.querySelector(sel); }

    // Elements (NO Liquid IDs)
    var elHasPo = q("select[id^='has-po-upload-']");
    // ===== TEMP: disable PDF upload option (Coming soon) =====
    function pdfComingSoonTemp_() {
      if (!elHasPo) return;

      // ✅ Allow YES + show label
      try {
        var opts = elHasPo.querySelectorAll("option");
        for (var i = 0; i < opts.length; i++) {
          if (String(opts[i].value || "").toLowerCase() === "yes") {
            opts[i].disabled = false;
            opts[i].textContent = "Yes";
          }
        }
      } catch (e2) {}

      // ✅ Keep the note (insert right after the select so it always shows)
      try {
        // remove existing note we previously inserted
        var existing2 = root.querySelector(".b2b__hint[data-po-note='1']");
        if (existing2) existing2.remove();

        var note = document.createElement("div");
        note.className = "b2b__hint";
        note.setAttribute("data-po-note", "1");
        note.style.fontSize = "12px";
        note.style.opacity = "0.75";
        note.style.marginTop = "6px";
        note.textContent =
          "PDF files only.";

        elHasPo.insertAdjacentElement("afterend", note);
      } catch (e3) {}

      // ✅ IMPORTANT: remove the “force back to no” handler entirely
      // (do not add any change listener here)
    }
    pdfComingSoonTemp_();

    var elUploadBlock = q("div[id^='upload-block-']");
    var elDeliveryBlock = q("div[id^='delivery-block-']");
    var elProductBlock = q("div[id^='product-block-']");

    var elEmail = q("input[id^='customer-email-']");
    var elComments = q("textarea[id^='comments-']");
    var elPackingNoteWrap = q("div[id^='packing-note-wrap-']");
    var elPackingNote = q("textarea[id^='packing-note-']");

    var elFile = q("input[id^='po-file-']");
    var elPoYes = q("input[id^='po-number-yes-']");
    var elPo = q("input[id^='po-number-']:not([id^='po-number-yes-'])");
    var elName = q("input[id^='delivery-name-']");
    var elPhone = q("input[id^='delivery-phone-']");
    var elInstr = q("input[id^='delivery-instructions-']");

    var elUnit = q("input[id^='unit-']");

    var elAddr1 = q("input[id^='addr1-']");
    var elAddr2 = q("input[id^='addr2-']");
    var elSuburb = q("input[id^='suburb-']");
    var elCity = q("input[id^='city-']");
    var elPost = q("input[id^='postcode-']");

    var elSubmit = q("button[id^='submit-b2b-']");
    var elStatus = q("div[id^='b2b-status-']");

    var elRepeat = q("input[id^='repeat-last-']");
    var elRepeatStatus = q("div[id^='repeat-status-']");

    var elSearch = q("input[id^='b2b-search-']");
    var elResults = q("div[id^='b2b-results-']");
    var elLines = q("div[id^='b2b-lines-']");

    var elTotal = q("div[id^='b2b-total-']");
    var elFee = q("div[id^='b2b-fee-']");
    var elSummary = q("div[id^='b2b-summary-']");
var elProductsTotal = q("div[id^='b2b-products-total-']");

    // State
    var customerFeeCents = 0;
    var customerFeeLabel = "Delivery Fee";
    var selectedLines = [];

    // Pricing rules (loaded per customer)
    var pricingMode = "regular";      // "regular" | "sale" | "discount10" (etc)
    var pricingOverrides = [];        // list of overrides from Apps Script

    // Shipping quote state (new)
    var shippingModeUsed = "";        // e.g. SHOPIFY / ARAMEX / ARAMEX+SIG / FIXED
    var shippingSubtotalNzd = 0;
    var latestPricedLines = [];
    var effectiveMappedEmail = "";

    // Utils
    function setStatus(msg) { if (elStatus) elStatus.textContent = msg || ""; }
    function setRepeatStatus(msg) { if (elRepeatStatus) elRepeatStatus.textContent = msg || ""; }

    function isValidEmail(v) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || "").trim());
    }
    function escapeHtml_(s) {
      return String(s || "")
        .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;").replace(/'/g, "&#039;");
    }
    function moneyToNumber(v) {
      var n = Number(String(v || "").replace(/[^0-9.\-]/g, ""));
      return isFinite(n) ? n : 0;
    }
    function formatMoney_(n) {
      return "$" + (Math.round(n * 100) / 100).toFixed(2);
    }
    function togglePackingNote_() {
      if (!elPackingNoteWrap) return;

      var rawEmail = (elEmail && elEmail.value ? elEmail.value.trim().toLowerCase() : "");
      var effectiveEmail = String(effectiveMappedEmail || rawEmail || "").toLowerCase();
      var show = effectiveEmail === "hello@thenestcollective.org.nz";

      elPackingNoteWrap.style.display = show ? "block" : "none";

      if (!show && elPackingNote) {
        elPackingNote.value = "";
      }
    }

    // Toggle PDF vs delivery/products
    function toggle() {
      var isYes = elHasPo && String(elHasPo.value || "").toLowerCase() === "yes";
      if (elUploadBlock) elUploadBlock.style.display = isYes ? "block" : "none";
      if (elDeliveryBlock) elDeliveryBlock.style.display = isYes ? "none" : "block";
      if (elProductBlock) elProductBlock.style.display = isYes ? "none" : "block";
      setStatus("");

      // If switching to PDF upload, shipping estimate is irrelevant
      // (keep fee display stable; no hard reset here)
    }
    if (elHasPo) elHasPo.addEventListener("change", toggle);
    toggle();
    togglePackingNote_();

    // Delivery fee render/load
    function renderFee_() {
      if (!elFee) return;
      var cents = Number(customerFeeCents || 0) || 0;
      var dollars = (cents / 100).toFixed(2);

      elFee.style.display = "block";

      // Show mode when available (non-breaking: still shows label + dollars)
      var modeTxt = shippingModeUsed ? (" (" + shippingModeUsed + ")") : "";
      elFee.innerHTML =
  '<div style="display:flex;justify-content:space-between;font-weight:600;">' +
    '<span>' + (customerFeeLabel || "Delivery Fee") + modeTxt + '</span>' +
    '<span>$' + dollars + '</span>' +
  '</div>';
    }

    // ---- NEW: build productsJson payload for quote (safe)
    function buildProductsJsonForQuote_() {
      // Keep same structure as your submit payload: selectedLines
      // Make sure qty + sku + variantId are present
      return JSON.stringify((selectedLines || []).map(function (ln) {
        return {
          variantId: ln.variantId,
          sku: ln.sku || "",
          qty: Number(ln.qty || 0) || 0,
          productTitle: ln.productTitle || "",
          variantTitle: ln.variantTitle || ""
        };
      }));
    }

    // ---- NEW: decide whether we have enough info to quote shipping
    function hasEnoughAddressForQuote_() {
      // For Shopify + Aramex you need at least addr1/city/postcode.
      // Phone/name help but don't block.
      if (!elAddr1 || !elCity || !elPost) return false;
      return !!(String(elAddr1.value || "").trim() && String(elCity.value || "").trim() && String(elPost.value || "").trim());
    }

    // ---- NEW: Quote endpoint (latest delivery fee call)
    // It also returns pricing info if your backend chooses to include it;
    // we keep the older deliveryFee endpoint as fallback.
    function loadFee_() {
      var email = (elEmail && elEmail.value ? elEmail.value.trim().toLowerCase() : "");

      // Default reset (same as before)
      function resetFee_() {
        customerFeeCents = 0;
        customerFeeLabel = "Delivery Fee";
        shippingModeUsed = "";
        shippingSubtotalNzd = 0;
        latestPricedLines = [];
        effectiveMappedEmail = "";
      }

      if (!email || !isValidEmail(email)) {
        resetFee_();
        pricingMode = "regular";
        pricingOverrides = [];
        togglePackingNote_();
        renderFee_();
        renderLines();
        return;
      }

      // If user is on PDF-upload mode, keep using legacy deliveryFee (simple)
      // because we don't have products/address and quote isn't meaningful.
      var isYes = elHasPo && String(elHasPo.value || "").toLowerCase() === "yes";
      if (isYes) {
        fetch(WEBAPP_URL + "?action=deliveryFee&email=" + encodeURIComponent(email))
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d && d.ok) {
              effectiveMappedEmail = String(d.debugMappedEmail || email || "").toLowerCase();
              togglePackingNote_();

              customerFeeCents = Number(d.feeCents || 0) || 0;
              customerFeeLabel = String(d.label || "Delivery Fee");
              shippingModeUsed = String(d.modeUsed || "") || "";
              shippingSubtotalNzd = Number(d.subtotalNzd || 0) || 0;

              pricingMode = String(d.pricingMode || "regular");
              pricingOverrides = Array.isArray(d.pricingOverrides) ? d.pricingOverrides : [];
            } else {
              resetFee_();
              pricingMode = "regular";
              pricingOverrides = [];
              effectiveMappedEmail = email || "";
              togglePackingNote_();
            }
            renderFee_();
            renderLines();
          })
          .catch(function () {
            resetFee_();
            pricingMode = "regular";
            pricingOverrides = [];
            effectiveMappedEmail = email || "";
            togglePackingNote_();
            renderFee_();
            renderLines();
          });

        return;
      }

      // Non-PDF mode: try latest shippingQuote FIRST if we have enough info
      var canQuote = (selectedLines && selectedLines.length) && hasEnoughAddressForQuote_();
      if (canQuote) {
        var qs =
          "action=shippingQuote" +
          "&email=" + encodeURIComponent(email) +
          "&name=" + encodeURIComponent(elName ? (elName.value || "") : "") +
          "&phone=" + encodeURIComponent(elPhone ? (elPhone.value || "") : "") +
          "&addr1=" + encodeURIComponent(elAddr1 ? (elAddr1.value || "") : "") +
          "&addr2=" + encodeURIComponent((function () {
            // match your submit behavior: addr2 + unit
            var unitVal = elUnit ? String(elUnit.value || "").trim() : "";
            var addr2Val = elAddr2 ? String(elAddr2.value || "").trim() : "";
            var combinedAddr2 = [addr2Val, unitVal ? ("Unit " + unitVal) : ""].filter(Boolean).join(", ");
            return combinedAddr2;
          })()) +
          "&suburb=" + encodeURIComponent(elSuburb ? (elSuburb.value || "") : "") +
          "&city=" + encodeURIComponent(elCity ? (elCity.value || "") : "") +
          "&postcode=" + encodeURIComponent(elPost ? (elPost.value || "") : "") +
          "&productsJson=" + encodeURIComponent(buildProductsJsonForQuote_());

        fetch(WEBAPP_URL + "?" + qs)
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d && d.ok) {
              effectiveMappedEmail = String(d.debugMappedEmail || email || "").toLowerCase();
              togglePackingNote_();

              customerFeeCents = Number(d.feeCents || 0) || 0;
              customerFeeLabel = String(d.label || "Delivery Fee");
              shippingModeUsed = String(d.modeUsed || "") || "";
              shippingSubtotalNzd = Number(d.subtotalNzd || 0) || 0;
              latestPricedLines = Array.isArray(d.pricedLines) ? d.pricedLines : [];

              // Optional pricing info; keep safe defaults if absent
              pricingMode = String(d.pricingMode || pricingMode || "regular");
              pricingOverrides = Array.isArray(d.pricingOverrides) ? d.pricingOverrides : pricingOverrides;

            } else {
              // If quote fails, fall back to legacy deliveryFee (so we never "break")
              return fetch(WEBAPP_URL + "?action=deliveryFee&email=" + encodeURIComponent(email))
                .then(function (r2) { return r2.json(); })
                .then(function (d2) {
                  if (d2 && d2.ok) {
                    effectiveMappedEmail = String(d2.debugMappedEmail || email || "").toLowerCase();
                    togglePackingNote_();

                    customerFeeCents = Number(d2.feeCents || 0) || 0;
                    customerFeeLabel = String(d2.label || "Delivery Fee");
                    shippingModeUsed = String(d2.modeUsed || "") || "";
                    shippingSubtotalNzd = Number(d2.subtotalNzd || 0) || 0;

                    pricingMode = String(d2.pricingMode || "regular");
                    pricingOverrides = Array.isArray(d2.pricingOverrides) ? d2.pricingOverrides : [];
                  } else {
                    resetFee_();
                    pricingMode = "regular";
                    pricingOverrides = [];
                    effectiveMappedEmail = email || "";
                    togglePackingNote_();
                  }
                });
            }
          })
          .then(function () {
            renderFee_();
            renderLines();
          })
          .catch(function () {
            // hard fallback: old endpoint
            fetch(WEBAPP_URL + "?action=deliveryFee&email=" + encodeURIComponent(email))
              .then(function (r) { return r.json(); })
              .then(function (d) {
                if (d && d.ok) {
                  effectiveMappedEmail = String(d.debugMappedEmail || email || "").toLowerCase();
                  togglePackingNote_();

                  customerFeeCents = Number(d.feeCents || 0) || 0;
                  customerFeeLabel = String(d.label || "Delivery Fee");
                  shippingModeUsed = String(d.modeUsed || "") || "";
                  shippingSubtotalNzd = Number(d.subtotalNzd || 0) || 0;

                  pricingMode = String(d.pricingMode || "regular");
                  pricingOverrides = Array.isArray(d.pricingOverrides) ? d.pricingOverrides : [];
                } else {
                  resetFee_();
                  pricingMode = "regular";
                  pricingOverrides = [];
                  effectiveMappedEmail = email || "";
                  togglePackingNote_();
                }
                renderFee_();
                renderLines();
              })
              .catch(function () {
                resetFee_();
                pricingMode = "regular";
                pricingOverrides = [];
                effectiveMappedEmail = email || "";
                togglePackingNote_();
                renderFee_();
                renderLines();
              });
          });

        return;
      }

      // Not enough info yet: do NOT call legacy deliveryFee, because it can overwrite a good shippingQuote with $0.
      return;
    }

    // IMPORTANT: Show ONE price only = what they pay.
    // For "search add", that's variant.price.
    // For "repeat order", we use li.unitPaid (server must send it), fallback to li.price if present.
    function getUnitPaid_(line) {
      if (line && line.unitPaid != null && String(line.unitPaid).trim() !== "") return moneyToNumber(line.unitPaid);
      if (line && line.price != null && String(line.price).trim() !== "") return moneyToNumber(line.price);
      return 0;
    }
function ensureProductsTotalRow_() {
  if (!elFee || !elTotal) return null;

  var existing = root.querySelector("div[data-b2b-products-total='1']");
  if (existing) return existing;

  var row = document.createElement("div");
  row.setAttribute("data-b2b-products-total", "1");

  // put it above delivery fee
 elTotal.parentNode.insertBefore(row, elTotal);

  return row;
}
    function renderLines() {
      if (!elLines) return;
      elLines.innerHTML = "";
      var total = 0;

      selectedLines.forEach(function (line, idx) {
        var qty = Number(line.qty || 0) || 0;

        // ONE PRICE ONLY: paid price
        var priced = null;
for (var p = 0; p < latestPricedLines.length; p++) {
  if (String(latestPricedLines[p].variantId || "") === String(line.variantId || "")) {
    priced = latestPricedLines[p];
    break;
  }
}

var unitPaid = priced ? moneyToNumber(priced.finalUnitPrice) : getUnitPaid_(line);
        if (unitPaid > 0) total += unitPaid * qty;

        var priceText = (unitPaid > 0) ? ("Price: " + formatMoney_(unitPaid)) : "";

        var div = document.createElement("div");
        div.className = "b2b__line";
        div.innerHTML =
          '<div>' +
            '<div class="b2b__lineTitle">' + escapeHtml_(line.productTitle) + '</div>' +
            '<div class="b2b__lineMeta">' +
              escapeHtml_((String(line.variantTitle || "").toLowerCase() === "default title") ? "" : (line.variantTitle || "")) +
              (priceText ? (" • " + escapeHtml_(priceText)) : "") +
            '</div>' +
          '</div>' +
          '<input class="b2b__qty" type="number" min="1" value="' + qty + '" data-idx="' + idx + '">' +
          '<button class="b2b__remove" type="button" title="Remove" data-idx="' + idx + '">×</button>';

        elLines.appendChild(div);
      });

            var feeNzd = (Number(customerFeeCents || 0) || 0) / 100;
      var grandTotal = total + feeNzd;
      var productsRow = ensureProductsTotalRow_();

if (productsRow) {
  productsRow.innerHTML =
    '<div style="display:flex;justify-content:space-between;">' +
      '<span>Products</span>' +
      '<span>' + formatMoney_(total) + '</span>' +
    '</div>';
}
      // Products subtotal row
if (elProductsTotal) {
  elProductsTotal.innerHTML =
    (total > 0)
    ? '<div style="display:flex;justify-content:space-between;">' +
        '<span>Products</span>' +
        '<span>' + formatMoney_(total) + '</span>' +
      '</div>'
    : "";
}

      // Show delivery fee ABOVE total
      if (elFee && elTotal && elFee.parentNode === elTotal.parentNode && elFee.nextSibling !== elTotal) {
        elTotal.parentNode.insertBefore(elFee, elTotal);
      }

      if (elTotal) {
       elTotal.innerHTML =
  (grandTotal > 0)
  ? '<div style="display:flex;justify-content:space-between;font-weight:700;border-top:1px solid #ddd;padding-top:8px;margin-top:6px;">' +
      '<span>Estimated total</span>' +
      '<span>' + formatMoney_(grandTotal) + '</span>' +
    '</div>'
  : "";
      }
    }

    // Qty change / remove
    if (elLines) {
      elLines.addEventListener("input", function (ev) {
        var t = ev.target;
        if (t && t.classList && t.classList.contains("b2b__qty")) {
          var idx = Number(t.getAttribute("data-idx"));
          var qv = Number(t.value || 1);
          if (qv < 1) qv = 1;
          if (selectedLines[idx]) selectedLines[idx].qty = qv;
          renderLines();
          loadFee_(); // NEW: re-quote shipping when quantities change
        }
      });

      elLines.addEventListener("click", function (ev) {
        var t = ev.target;
        if (t && t.classList && t.classList.contains("b2b__remove")) {
          var idx = Number(t.getAttribute("data-idx"));
          selectedLines.splice(idx, 1);
          renderLines();
          loadFee_(); // NEW: re-quote shipping when cart changes
        }
      });
    }

    // Repeat last order
    function loadLastOrder_() {
      var email = (elEmail && elEmail.value ? elEmail.value.trim().toLowerCase() : "");
      if (!email) { setRepeatStatus("Please enter your email first."); return; }
      if (!isValidEmail(email)) { setRepeatStatus("Please enter a valid email first."); return; }

      setRepeatStatus("Loading your last order…");
      fetch(WEBAPP_URL + "?action=lastOrder&email=" + encodeURIComponent(email))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data || !data.ok) { setRepeatStatus("Could not load previous order."); return; }
          if (!data.found || !data.lines || !data.lines.length) { setRepeatStatus("No previous orders found for this email."); return; }

          effectiveMappedEmail = String(data.debugMappedEmail || email || "").toLowerCase();
          togglePackingNote_();

          selectedLines = data.lines.map(function (li) {
            return {
              variantId: li.variantId,
              sku: li.sku || "",
              productTitle: li.productTitle || "",
              variantTitle: li.variantTitle || "",
              qty: li.qty || 1,

              // server should provide unitPaid (what they paid)
              unitPaid: (li.unitPaid != null ? String(li.unitPaid) : (li.price != null ? String(li.price) : ""))
            };
          });

          // ✅ merge any duplicates from last order (same variantId)
          var merged = [];
          selectedLines.forEach(function (ln) {
            var found = null;
            for (var i = 0; i < merged.length; i++) {
              if (String(merged[i].variantId) === String(ln.variantId)) { found = merged[i]; break; }
            }
            if (found) {
              found.qty = Number(found.qty || 1) + Number(ln.qty || 1);
            } else {
              merged.push(ln);
            }
          });
          selectedLines = merged;

          renderLines();
          setRepeatStatus("Loaded your last order. You can adjust quantities before submitting.");
          loadFee_(); // will now try shippingQuote if address is filled
        })
        .catch(function (err) {
          setRepeatStatus("Load error: " + (err && err.message ? err.message : err));
        });
    }

    if (elRepeat) {
      elRepeat.addEventListener("change", function () {
        setRepeatStatus("");
        if (elRepeat.checked) loadLastOrder_();
      });
    }

    // Fee loads reliably
    var feeTimer = null;
    if (elEmail) {
      elEmail.addEventListener("input", function () {
        togglePackingNote_();
        if (feeTimer) clearTimeout(feeTimer);
        feeTimer = setTimeout(function () { loadFee_(); }, 350);
      });
      elEmail.addEventListener("blur", function () {
        togglePackingNote_();
        loadFee_();
        if (elRepeat && elRepeat.checked) loadLastOrder_();
      });
    }

    // NEW: re-quote shipping when address changes (debounced)
    function hookQuoteOnAddr_(el) {
      if (!el) return;
      el.addEventListener("input", function () {
        if (feeTimer) clearTimeout(feeTimer);
        feeTimer = setTimeout(function () { loadFee_(); }, 450);
      });
      el.addEventListener("blur", function () {
        loadFee_();
      });
    }
    hookQuoteOnAddr_(elName);
    hookQuoteOnAddr_(elPhone);
    hookQuoteOnAddr_(elAddr1);
    hookQuoteOnAddr_(elAddr2);
    hookQuoteOnAddr_(elSuburb);
    hookQuoteOnAddr_(elCity);
    hookQuoteOnAddr_(elPost);
    hookQuoteOnAddr_(elUnit);

    // Product search
    var searchTimer = null;
    if (elSearch) {
      elSearch.addEventListener("input", function () {
        var qv = elSearch.value.trim();
        if (searchTimer) clearTimeout(searchTimer);
        if (qv.length < 2) { if (elResults) { elResults.style.display = "none"; elResults.innerHTML = ""; } return; }
        searchTimer = setTimeout(function () { runSearch_(qv); }, 250);
      });
    }

    function runSearch_(qv) {
      fetch("/search/suggest.json?q=" + encodeURIComponent(qv) + "&resources[type]=product&resources[limit]=6")
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (((data || {}).resources || {}).results || {}).products || [];
          if (!elResults) return;

          elResults.style.display = "block";
          elResults.innerHTML = "";

          if (!products.length) {
            elResults.innerHTML = '<div class="b2b__resultItem"><div class="b2b__resultTitle">No results</div><div></div></div>';
            return;
          }

          products.forEach(function (p) {
            var item = document.createElement("div");
            item.className = "b2b__resultItem";
            item.setAttribute("data-handle", p.handle);

            // ✅ Product row (NOT variant row)
            item.innerHTML =
              '<div class="b2b__resultTitle">' + escapeHtml_(p.title) + '</div>' +
              '<div class="b2b__selectBadge">Select</div>';

            elResults.appendChild(item);
          });
        })
        .catch(function () {
          if (!elResults) return;
          elResults.style.display = "block";
          elResults.innerHTML = '<div class="b2b__resultItem"><div class="b2b__resultTitle">Search error</div><div></div></div>';
        });
    }

    // ✅ One-time click handler for product rows (loads variants)
    if (elResults) {
      elResults.addEventListener("click", function (ev) {
        // Click can land on inner elements (title/badge). Walk up safely.
        var item = ev.target && ev.target.closest ? ev.target.closest(".b2b__resultItem") : null;
        if (!item) return;

        // Only product rows have data-handle
        var handle = item.getAttribute("data-handle");
        if (!handle) return; // ignore variant rows

        ev.preventDefault();
        ev.stopPropagation();

        loadProductVariants_(handle);
      }, true); // <-- CAPTURE makes it more reliable
    }

    function addOrBumpLine_(newLine) {
      var vid = String(newLine.variantId || "");
      for (var i = 0; i < selectedLines.length; i++) {
        if (String(selectedLines[i].variantId || "") === vid) {
          selectedLines[i].qty = Number(selectedLines[i].qty || 1) + Number(newLine.qty || 1);
          return;
        }
      }
      selectedLines.push(newLine);
    }

    function getFinalVariantPrice_(v) {
      var basePrice = v.price; // Shopify price in cents

      // Base price to discount from: use compare_at_price if present, else price
      if (v.compare_at_price && v.compare_at_price > 0) {
        basePrice = v.compare_at_price;
      } else {
        basePrice = v.price;
      }

      // 2️⃣ Apply overrides (if any)
      for (var i = 0; i < pricingOverrides.length; i++) {
        var o = pricingOverrides[i];

        var sku = String(v.sku || "").trim().toUpperCase();
        var mv  = String(o.matchValue || "").trim().toUpperCase();

        var match =
          (String(o.matchType || "").toLowerCase() === "sku" && (mv === sku || mv === "ALL SKUS")) ||
          (String(o.matchType || "").toLowerCase() === "variantid" && String(o.matchValue) === String(v.id));

        if (!match) continue;

        if (o.priceType === "fixed") {
          return Math.round(Number(o.value) * 100); // dollars → cents
        }

        if (o.priceType === "percentOff") {
          return Math.round(basePrice * (1 - Number(o.value) / 100));
        }
      }

      return basePrice;
    }

    function loadProductVariants_(handle) {
      if (!elResults) return;

      elResults.style.display = "block";
      elResults.innerHTML =
        '<div class="b2b__resultItem"><div class="b2b__resultTitle">Loading…</div><div></div></div>';

      fetch("/products/" + encodeURIComponent(handle) + ".js")
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var variants = p.variants || [];
          elResults.innerHTML = "";

          if (!variants.length) {
            elResults.innerHTML =
              '<div class="b2b__resultItem"><div class="b2b__resultTitle">No variants available</div><div></div></div>';
            return;
          }

          // ✅ If only 1 variant (typical "no variants" product), add it immediately
          if (variants.length === 1) {
            var v = variants[0];

            addOrBumpLine_({
              variantId: v.id,
              sku: v.sku || "",
              productTitle: p.title || "",
              variantTitle: v.title || "",
              qty: 1,
              unitPaid: (getFinalVariantPrice_(v) / 100).toFixed(2)
            });

            elResults.style.display = "none";
            elResults.innerHTML = "";
            if (elSearch) elSearch.value = "";

            renderLines();
            loadFee_(); // will now prefer shippingQuote if address is filled
            return;
          }

          // Otherwise show variants list for selection
          variants.forEach(function (v) {
            var row = document.createElement("div");
            row.className = "b2b__resultItem b2b__resultItem--variant";

            var vTitle = (v.title && String(v.title).toLowerCase() === "default title") ? "" : v.title;

            row.innerHTML =
              '<div class="b2b__resultTitle">' +
                escapeHtml_(p.title) + (vTitle ? (' — ' + escapeHtml_(vTitle)) : '') +
              '</div>' +
              '<div class="b2b__selectBadge">Select</div>';

            row.addEventListener("click", function (e) {
              e.preventDefault();
              e.stopPropagation();

              addOrBumpLine_({
                variantId: v.id,
                sku: v.sku || "",
                productTitle: p.title || "",
                variantTitle: v.title || "",
                qty: 1,
                unitPaid: (getFinalVariantPrice_(v) / 100).toFixed(2)
              });

              elResults.style.display = "none";
              elResults.innerHTML = "";
              if (elSearch) elSearch.value = "";

              renderLines();
              loadFee_(); // NEW: re-quote shipping after add
            });

            elResults.appendChild(row);
          });
        })
        .catch(function () {
          elResults.innerHTML =
            '<div class="b2b__resultItem"><div class="b2b__resultTitle">Variant load error</div><div></div></div>';
        });
    }

    function fileToBase64(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onerror = function () { reject(new Error("Could not read file")); };
        reader.onload = function () {
          var res = String(reader.result || "");
          var idx = res.indexOf("base64,");
          if (idx === -1) return reject(new Error("Invalid base64 format"));
          resolve(res.substring(idx + 7));
        };
        reader.readAsDataURL(file);
      });
    }

    async function submitForm() {
      setStatus("");

      var customerEmail = (elEmail && elEmail.value ? elEmail.value.trim() : "").toLowerCase();
      if (!customerEmail || !isValidEmail(customerEmail)) { setStatus("Please enter a valid customer email."); return; }

      var isYes = elHasPo && elHasPo.value === "yes";

      if (isYes) {
        var f = elFile && elFile.files && elFile.files[0];
        if (!f) { setStatus("Please upload your PO PDF."); return; }
        if (f.type !== "application/pdf") { setStatus("Please upload a PDF file."); return; }
      } else {
        if (!elName || !elName.value.trim()) { setStatus("Please enter Business / Full Name."); return; }
        if (!selectedLines.length) { setStatus("Please add at least one product."); return; }
        if (!elAddr1 || !elAddr1.value.trim()) { setStatus("Please enter Address line 1."); return; }
        if (!elCity || !elCity.value.trim()) { setStatus("Please enter City."); return; }
        if (!elPost || !elPost.value.trim()) { setStatus("Please enter Postcode."); return; }
      }

      var unitVal = elUnit ? elUnit.value.trim() : "";
      var addr2Val = elAddr2 ? elAddr2.value.trim() : "";
      var combinedAddr2 = [addr2Val, unitVal ? ("Unit " + unitVal) : ""].filter(Boolean).join(", ");

      var turnstileToken = "";
      try { if (window.turnstile) turnstileToken = window.turnstile.getResponse(); } catch (e) {}

      var captchaBlock = q("div[id^='captcha-block-']");
      if (captchaBlock && captchaBlock.offsetParent !== null) {
        if (!turnstileToken) { setStatus("Please complete the security check."); return; }
      }

      var payload = {
        turnstileToken: turnstileToken,
        customerEmail: customerEmail,
        hasPdf: !!isYes,
        // ✅ PO number: always take the filled one (handles selector collisions safely)
        poNumber: (function () {
          var a = isYes ? (elPoYes ? elPoYes.value.trim() : "") : (elPo ? elPo.value.trim() : "");
          if (a) return a;
          // fallback: if the other field has a value, use it
          var b = (!isYes) ? (elPoYes ? elPoYes.value.trim() : "") : (elPo ? elPo.value.trim() : "");
          return b || "";
        })(),
        deliveryName: elName ? elName.value.trim() : "",
        deliveryPhone: elPhone ? elPhone.value.trim() : "",
        addr1: elAddr1 ? elAddr1.value.trim() : "",
        addr2: combinedAddr2,
        unit: unitVal,
        suburb: elSuburb ? elSuburb.value.trim() : "",
        city: elCity ? elCity.value.trim() : "",
        postcode: elPost ? elPost.value.trim() : "",
        deliveryInstructions: elInstr ? elInstr.value.trim() : "",
        comments: elComments ? elComments.value.trim() : "",
        packingNote: elPackingNote ? elPackingNote.value.trim() : "",
        productsJson: isYes ? "" : JSON.stringify(selectedLines),

        // keep these the same (server trusts them as "what UI showed")
        deliveryFeeCents: customerFeeCents,
        deliveryFeeLabel: customerFeeLabel,

        // NEW (safe additions): helpful debug / auditing on server side
        deliveryFeeMode: shippingModeUsed || ""
      };

      try {
        if (elSubmit) elSubmit.disabled = true;
        setStatus(isYes ? "Uploading PDF and submitting… please do not close the window. This may take a minute." : "Submitting…");

        if (isYes) {
          var file = elFile.files[0];
          payload.pdfFileName = file && file.name ? file.name : "purchase-order.pdf";
          payload.pdfBase64 = await fileToBase64(file);
        }

        const res = await fetch(WEBAPP_URL, {
          method: "POST",
          headers: { "Content-Type": "text/plain;charset=UTF-8" },
          body: JSON.stringify(payload)
        });

        const txt = await res.text();
        let out = {};
        try { out = JSON.parse(txt); } catch (e) {}

        if (!out.ok) {
          throw new Error(out.error || "Submission failed");
        }

        // BIG success screen (we can't read response due to CORS, but request is sent)
        var bodyEl = root.querySelector(".b2b__body");
        if (bodyEl) {
          bodyEl.innerHTML =
            '<div style="padding:40px 18px;text-align:center;">' +
              '<div style="display:inline-block;padding:10px 14px;border-radius:999px;background:rgba(0,0,0,.06);font-weight:800;">Request received ✅</div>' +
              '<h2 style="font-size:26px;margin:18px 0 10px;">Thanks! We’ve got it.</h2>' +
              '<p style="font-size:16px;margin:0 0 10px;">We’ll review your business order request and email you an invoice shortly.</p>' +
              '<p style="font-size:13px;opacity:.75;margin:0 0 22px;">If you don’t hear from us within 24 hours, please email <b>info@babyonline.co.nz</b></p>' +
              '<button type="button" id="b2b-another-order" ' +
                'style="border:0;border-radius:14px;padding:14px 22px;font-size:15px;font-weight:800;cursor:pointer;background:#2F5BFF;color:#fff;">' +
                'Submit another order</button>' +
            '</div>';

          // Reload the page for a fresh form
          var btn = root.querySelector("#b2b-another-order");
          if (btn) {
            btn.addEventListener("click", function () {
              window.location.reload();
            });
          }
        } else {
          setStatus("Request received ✅ We’ll email you an invoice shortly.");
        }

      } catch (err) {
        setStatus("Network error: " + (err && err.message ? err.message : err));
      } finally {
        if (elSubmit) elSubmit.disabled = false;
        try { if (window.turnstile) window.turnstile.reset(); } catch (e) {}
      }
    }

    if (elSubmit) elSubmit.addEventListener("click", submitForm);

    // Google Places init (only if script loaded)
    function initPlacesIfReady_() {
      if (!window.google || !google.maps || !google.maps.places) return false;
      if (!elAddr1) return true;

      try {
        var ac = new google.maps.places.Autocomplete(elAddr1, {
          types: ["address"],
          componentRestrictions: { country: "nz" },
          fields: ["address_components"]
        });

        function getComp_(comps, type) {
          for (var i = 0; i < comps.length; i++) {
            if ((comps[i].types || []).indexOf(type) !== -1) return comps[i].long_name || "";
          }
          return "";
        }

        ac.addListener("place_changed", function () {
          var place = ac.getPlace();
          if (!place || !place.address_components) return;
          var comps = place.address_components;

          if (elSuburb) elSuburb.value = "";
          if (elCity) elCity.value = "";
          if (elPost) elPost.value = "";

          var subpremise = getComp_(comps, "subpremise");
          var premise = getComp_(comps, "premise");
          var streetNo = getComp_(comps, "street_number");
          var route = getComp_(comps, "route");

          var suburb =
            getComp_(comps, "sublocality") ||
            getComp_(comps, "sublocality_level_1") ||
            getComp_(comps, "sublocality_level_2") ||
            getComp_(comps, "neighborhood") ||
            getComp_(comps, "locality");

          var city =
            getComp_(comps, "postal_town") ||
            getComp_(comps, "locality") ||
            getComp_(comps, "administrative_area_level_2");

          var postcode = getComp_(comps, "postal_code");

          var typedAddr1 = (elAddr1 && elAddr1.value) ? elAddr1.value.trim() : "";

          function extractUnit_(s) {
            s = String(s || "").trim();
            var m = s.match(/\b(?:unit|apt|apartment|suite|ste)\s*([A-Za-z0-9]+)\b/i);
            if (m && m[1]) return m[1];
            m = s.match(/^([A-Za-z0-9]+)\s*\/\s*\d+\b/);
            if (m && m[1]) return m[1];
            return "";
          }

          var addr1 = (streetNo ? (streetNo + " ") : "") + (route || "");
          if (addr1) elAddr1.value = addr1;

          var u = subpremise || extractUnit_(typedAddr1);
          if (elUnit) elUnit.value = u || "";

          if (elAddr2) elAddr2.value = premise ? premise : (elAddr2.value || "");

          if (suburb && elSuburb) elSuburb.value = suburb;
          if (city && elCity) elCity.value = city;
          if (postcode && elPost) elPost.value = postcode;

          // NEW: after Places fills address, re-quote
          loadFee_();
        });

        return true;
      } catch (e) {
        return true;
      }
    }

    (function waitForPlaces_() {
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        if (initPlacesIfReady_() || tries >= 20) clearInterval(timer);
      }, 300);
    })();

    // Load fee on init (covers autofill)
    loadFee_();
  });
});